import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'day',
})
export class DayPipe implements PipeTransform {
  /**
   * Transform
   *
   * @param {number} value
   * @returns {string}
   */
  transform(value: number | null): string {

    if (value) {
      return value === 1 ? `${value} giorno` : `${value} giorni`;
    }

    return null;
  }
}
